package com.dotdrives.core

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

abstract class DotController<S>(
    initial: S,
    protected val scope: CoroutineScope,
) {
    private val mutableState = MutableStateFlow(initial)

    val state: StateFlow<S> = mutableState.asStateFlow()

    protected fun update(transform: (S) -> S) {
        mutableState.update(transform)
    }
}
